var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.678,
    height: 19,
    viewBox: "0 0 35.678 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2129",
    "data-name": "Group 2129",
    transform: "translate(-1106.5 -249.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-settings",
    "data-name": "Icon feather-settings",
    transform: "translate(1105.5 248.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M18.409,15.955A2.455,2.455,0,1,1,15.955,13.5,2.455,2.455,0,0,1,18.409,15.955Z",
    transform: "translate(-5.455 -5.455)",
    fill: "none",
    stroke: "#12819c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M16.555,12.955a1.35,1.35,0,0,0,.27,1.489l.049.049a1.637,1.637,0,1,1-2.315,2.315l-.049-.049a1.361,1.361,0,0,0-2.307.965v.139a1.636,1.636,0,1,1-3.273,0V17.79a1.35,1.35,0,0,0-.884-1.235,1.35,1.35,0,0,0-1.489.27l-.049.049a1.637,1.637,0,1,1-2.315-2.315l.049-.049A1.361,1.361,0,0,0,3.275,12.2H3.136a1.636,1.636,0,1,1,0-3.273H3.21a1.35,1.35,0,0,0,1.235-.884,1.35,1.35,0,0,0-.27-1.489l-.049-.049A1.637,1.637,0,1,1,6.442,4.192l.049.049a1.35,1.35,0,0,0,1.489.27h.065a1.35,1.35,0,0,0,.818-1.235V3.136a1.636,1.636,0,0,1,3.273,0V3.21a1.361,1.361,0,0,0,2.307.965l.049-.049a1.637,1.637,0,1,1,2.315,2.315l-.049.049a1.35,1.35,0,0,0-.27,1.489v.065a1.35,1.35,0,0,0,1.235.818h.139a1.636,1.636,0,0,1,0,3.273H17.79a1.35,1.35,0,0,0-1.235.818Z",
    fill: "none",
    stroke: "#12819c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1131 257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M5,7.5l5,5,5-5",
    transform: "translate(-5 -7.5)",
    fill: "none",
    stroke: "#12819c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.7b8a7e689ba956522d0cc26b35e488ba.svg";
export { ForwardRef as ReactComponent };